import { render, staticRenderFns } from "./meal-categories.vue?vue&type=template&id=5750c56b&scoped=true"
import script from "./meal-categories.vue?vue&type=script&lang=js"
export * from "./meal-categories.vue?vue&type=script&lang=js"
import style0 from "./meal-categories.vue?vue&type=style&index=0&id=5750c56b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5750c56b",
  null
  
)

export default component.exports